import styled from "styled-components";
import { Row } from "../../../components/flex/styled";
import { useContext } from "react";
import { Context } from "../../../context";

export const SetUpYourCompanyWrapper = styled("div")(() => {
  const { isPaymentFormModalOpen } = useContext(Context);
  return {
    "& .setup-main-area": {
      gap: 0,
      opacity: isPaymentFormModalOpen ? 0.1 : 1,
      pointerEvents: isPaymentFormModalOpen ? "none" : "auto",
      minHeight: "100vh",
    },
    "& .image-container": {
      flex: 1,
      overflow: "hidden",
      padding: "calc(var(--cardPadding) * 2)",
      backgroundColor: "#286c2b",
      color: "#FFFFFF",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
    },
    "& .image-container>svg": {
      width: "100%",
      height: "auto",
    },
    "& .set-up-form": {
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap) * 1.5)",
      marginBlock: "calc(var(--sectionMargin))",
      overflow: "hidden",
    },
    "& .form-container": {
      flex: 1,
      backgroundColor: "var(--color-background)",
      overflow: "hidden",
      padding: "calc(var(--cardPadding) * 2)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      "& h1": {
        margin: 0,
      },
      "& p": {
        margin: 0,
      },
    },
    "& .form-container fieldset": {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      gap: "calc(var(--flexGap)/8)",
      flexDirection: "column",
      justifyContent: "space-between",
      
    },
    "& .terms-fieldset": {
      display: "flex",
      flexDirection: "row",
      gap: "calc(var(--flexGap)/4)",
      "& input": {
        margin: 0,
        display: "inline",
        width: "20px",
      },
    },
    "& .form-container label": {
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "var(--color-text)",
    },
    "& .form-container input, & .form-container select": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) /2)",
      outline: "none",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: ".45rem",
      fontWeight: "400",
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-background)",
      padding: "calc(var(--cardPadding) * 1)",
      borderRadius: "1rem",
      boxShadow: "0px 20px 24px -4px #10182814",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
    },

    "& .image-container > div:last-child": {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    "@media screen and (max-width: 425px)": {
      "& .image-container": {
        padding: "calc(var(--cardPadding))",
      },
      "& .form-container": {
        padding: "calc(var(--cardPadding))",
      },
      "& .payment-modal": {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transform: "unset",
        borderRadius: 0,
        "& .payment-form": {
          alignItems: "unset",
          justifyContent: "unset",
          padding: "unset",
        },
      },
    },
    "@media screen and (max-width: 1024px)": {
      "& h1": {
        marginBlock: 0,
      },
      "& form": {
        gap: "var(--flexGap)",
      },
      "& .logo-box-area": {
        maxWidth: "50%",
        marginBlockEnd: "0",
        "& svg": {
          width: "100%",
          height: "auto",
        },
      },
    },
    "@media screen and (min-width: 1440px)": {
      "& .form-container button": {
        marginLeft: "auto",
        width: "fit-content",
      },
    },
  };
});

export const FieldSetRow = styled(Row)(() => {
  return {
    "@media screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  };
});
